import { useTranslation } from 'react-i18next'
import ReauthenticationDialog from 'modules/home/components/ReauthenticationDialog'
import { ConfirmActionDialog } from 'shared/components'
import { SystemAdminModeDenial } from 'shared/types'

interface SystemAdminModeDenialDialogsProps {
  denial: SystemAdminModeDenial | null
  onClose: () => void
  onReauthenticated: () => Promise<void>
  onEnableTwoFactor: () => void
}

const SystemAdminModeDenialDialogs = ({
  denial,
  onClose,
  onReauthenticated,
  onEnableTwoFactor,
}: SystemAdminModeDenialDialogsProps) => {
  const { t } = useTranslation()

  return (
    <>
      {denial === SystemAdminModeDenial.SESSION_EXPIRED && (
        <ReauthenticationDialog
          title={t('viewerMode.sessionExpiredLogin.title')}
          subtitle={t('viewerMode.systemAdmin')}
          message={t('viewerMode.sessionExpiredLogin.message')}
          onClose={onClose}
          onReauthenticated={onReauthenticated}
        />
      )}
      <ConfirmActionDialog
        open={denial === SystemAdminModeDenial.TWO_FACTOR_REQUIRED}
        onClose={onClose}
        onConfirm={onEnableTwoFactor}
        title={t('viewerMode.twoFactorRequired.title')}
        message={t('viewerMode.twoFactorRequired.message')}
        confirmLabel={t('viewerMode.twoFactorRequired.enable')}
      />
    </>
  )
}

export default SystemAdminModeDenialDialogs
